import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { breakpoints, useMatchMedia } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

export const ReviewLinkBanner = () => {
  const isSmallScreen = useMatchMedia({ maxWidth: breakpoints.small.min });

  const bannerStyle = css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(isSmallScreen ? 1.5 : 2)};
    border: 1px solid ${theme.colors.secondary.seaweed50};
    background-color: ${theme.colors.secondary.seaweed5};
    border-radius: ${theme.borderRadius.medium};
    padding: ${theme.spacing(isSmallScreen ? 1.5 : 2)};
    margin-bottom: ${theme.spacing(isSmallScreen ? 1 : 1.75)};
  `;

  const newSpanTagStyle = css`
    height: fit-content;
    border-radius: ${theme.borderRadius.small};
    background-color: ${theme.colors.secondary.seaweed50};
    color: ${theme.colors.white};
    padding: ${theme.spacing(0.25, 1)};
    font-size: ${isSmallScreen ? theme.font.size.small : theme.font.size.medium};
  `;

  const { t } = useTranslation('templates-settings');

  return (
    <div css={bannerStyle}>
      <span css={newSpanTagStyle}>{t('New')}</span>
      <Text size={isSmallScreen ? 'small' : 'medium'}>
        {t(
          'Review links are now customizable. You can create and edit multiple landing pages or skip the landing page altogether. Start customizing what your contacts see below.'
        )}
      </Text>
    </div>
  );
};
